export interface RegulatorySettings {
    approach?: string;
    institution_classification?: string;
    supervisory_authority?: string;
    business_model?: string[];
}

export const BUSINESS_MODEL_OPTIONS = [
    { value: 'Retail Banking', label: 'Retail banking' },
    { value: 'Investment Banking', label: 'Investment banking' },
    { value: 'Corporate Banking', label: 'Corporate banking' },
    { value: 'Asset Management', label: 'Asset management' },
    { value: 'Insurance', label: 'Insurance' },
    { value: 'Trading', label: 'Trading' },
    { value: 'Payment Services', label: 'Payment services' },
] as const;
